import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Pending = () => {

    const navigate = useNavigate();
  const styles = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      margin: 0,
      padding: '20px',
      boxSizing: 'border-box'
    },
    card: {
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: '40px 60px',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
      textAlign: 'center',
      maxWidth: '500px',
      width: '100%',
      animation: 'fadeIn 0.5s ease-in'
    },
    spinner: {
      width: '50px',
      height: '50px',
      border: '5px solid #f3f3f3',
      borderTop: '5px solid #3498db',
      borderRadius: '50%',
      margin: '0 auto 25px',
      animation: 'spin 1s linear infinite'
    },
    message: {
      fontSize: '1.2rem',
      color: '#333',
      marginBottom: '15px',
      fontWeight: '500',
      lineHeight: '1.6'
    },
    submessage: {
      fontSize: '0.95rem',
      color: '#666',
      marginTop: '10px',
      fontStyle: 'italic'
    },
    '@keyframes spin': {
      '0%': { transform: 'rotate(0deg)' },
      '100%': { transform: 'rotate(360deg)' }
    },
    '@keyframes fadeIn': {
      '0%': { opacity: 0, transform: 'translateY(-20px)' },
      '100%': { opacity: 1, transform: 'translateY(0)' }
    }
  };

  // Add keyframes to document for inline styles
  const styleSheet = document.createElement("style");
  styleSheet.textContent = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    @keyframes fadeIn {
      0% { opacity: 0; transform: translateY(-20px); }
      100% { opacity: 1; transform: translateY(0); }
    }
  `;
  document.head.appendChild(styleSheet);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.spinner}></div>
        <p style={styles.message}>
          Please wait while the payment status is being updated.
          Please check the payment status by loggin in after 90 mins
        </p>
        <p style={styles.submessage}>
          This may take a few moments...
        </p>
        <button onClick={
          () => navigate("/login")
        }>
          To login page
        </button>
      </div>
    </div>
  );
};

export default Pending;